export default "__VITE_ASSET__d8b611f7__"